export default __webpack_public_path__ + "static/media/Billing_Default.309d50f9.svg";